import apiFetch from '../apiFetch'

export default function (token, filter) {
  return apiFetch({ endPoint: 'Masters/CustomField/List', method: 'POST', body: filter, token: token })
}
